import Swal from 'sweetalert2';

// Get current theme for SweetAlert2 styling
const getTheme = () => document.documentElement.getAttribute('data-bs-theme') || 'light';

const getBaseConfig = () => {
    const isDark = getTheme() === 'dark';
    return {
        background: isDark ? '#1A1A2E' : '#ffffff',
        color: isDark ? '#EAEAF5' : '#1B2559',
        confirmButtonColor: '#6C5DD3',
        cancelButtonColor: isDark ? '#2D2D4A' : '#E9EDF7',
        customClass: {
            popup: 'swal-custom-popup',
            confirmButton: 'swal-confirm-btn',
            cancelButton: 'swal-cancel-btn',
            title: 'swal-title',
        },
        buttonsStyling: true,
        reverseButtons: true,
        showClass: {
            popup: 'animate__animated animate__fadeInUp animate__faster'
        },
        hideClass: {
            popup: 'animate__animated animate__fadeOutDown animate__faster'
        }
    };
};

export const showSuccess = (title, text) => {
    return Swal.fire({
        ...getBaseConfig(),
        icon: 'success',
        title: title || 'Success!',
        text: text || '',
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
    });
};

export const showError = (title, text) => {
    return Swal.fire({
        ...getBaseConfig(),
        icon: 'error',
        title: title || 'Error!',
        text: text || 'Something went wrong.',
        confirmButtonText: 'OK',
    });
};

export const showWarning = (title, text) => {
    return Swal.fire({
        ...getBaseConfig(),
        icon: 'warning',
        title: title || 'Warning!',
        text: text || '',
        confirmButtonText: 'OK',
    });
};

export const showInfo = (title, text) => {
    return Swal.fire({
        ...getBaseConfig(),
        icon: 'info',
        title: title || 'Info',
        text: text || '',
        confirmButtonText: 'Got it',
    });
};

export const showConfirm = (title, text, confirmText = 'Yes, proceed', cancelText = 'Cancel') => {
    return Swal.fire({
        ...getBaseConfig(),
        icon: 'question',
        title: title || 'Are you sure?',
        text: text || '',
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
    });
};

export const showConfirmDanger = (title, text, confirmText = 'Yes, delete', cancelText = 'Cancel') => {
    return Swal.fire({
        ...getBaseConfig(),
        icon: 'warning',
        title: title || 'Are you sure?',
        text: text || 'This action cannot be undone.',
        showCancelButton: true,
        confirmButtonText: confirmText,
        confirmButtonColor: '#FF5B5B',
        cancelButtonText: cancelText,
    });
};

export const showPasswordPrompt = (title, text, confirmText = 'Confirm') => {
    return Swal.fire({
        ...getBaseConfig(),
        icon: 'shield-lock',
        title: title || 'Enter Password',
        text: text || '',
        input: 'password',
        inputPlaceholder: 'Enter your password',
        showCancelButton: true,
        confirmButtonText: confirmText,
        inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
        },
        inputValidator: (value) => {
            if (!value) {
                return 'Password is required!';
            }
        }
    });
};

// Special modal for sale completion with print option
export const showSaleComplete = (invoiceNumber, totalAmount) => {
    const isDark = getTheme() === 'dark';
    return Swal.fire({
        ...getBaseConfig(),
        icon: 'success',
        title: 'Sale Completed! 🎉',
        html: `
            <div style="text-align: center; padding: 10px 0;">
                <p style="font-size: 1rem; color: ${isDark ? '#A3AED0' : '#8F9BBA'}; margin-bottom: 8px;">Invoice Number</p>
                <p style="font-size: 1.4rem; font-weight: 700; color: #6C5DD3; margin-bottom: 16px;">${invoiceNumber}</p>
                <p style="font-size: 0.95rem; color: ${isDark ? '#A3AED0' : '#8F9BBA'}; margin-bottom: 4px;">Total Amount</p>
                <p style="font-size: 1.8rem; font-weight: 800; color: ${isDark ? '#EAEAF5' : '#1B2559'};">Rs. ${totalAmount}</p>
            </div>
        `,
        showCancelButton: true,
        confirmButtonText: '🖨️ Print Bill',
        cancelButtonText: 'Done',
        confirmButtonColor: '#6C5DD3',
    });
};

export default Swal;
